module.exports = __webpack_public_path__ + "static/img/VolunteerIn_20th_anniversary.bc821a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/VolunteerIn_20th_anniversary.jpg
// module id = ztzX
// module chunks = 0